// Lib
import { List } from 'immutable';
import { pick } from 'lodash/fp';

// Utils
import { asObject } from '../../../../common/utils/immutableHelper';
import { getReactionEmojiCode, getReactionUserId } from '../reactionUtil';
import { getReactions } from '../../../../common/elements/utils/elementPropertyUtils';

// Selectors
import { getAllComments } from '../../comment/store/commentsSelector';
import { getCurrentUserId } from '../../../user/currentUserSelector';
import { getRenderedElements } from '../../selection/selectedElementsSelector';

export const getSelectedReactionIds = (state: any, selectedElementIds: string[]): string[] => {
    const elements = state.get('elements');
    const comments = getAllComments(state);
    const currentUserId = getCurrentUserId(state);

    const selectedElements = getRenderedElements(selectedElementIds, elements);
    const selectedComments = Object.values(pick(selectedElementIds, comments));

    const selectedItems = List.of(...selectedElements, ...selectedComments);

    return asObject(
        selectedItems
            .flatMap(getReactions)
            .filter((reaction) => getReactionUserId(reaction) === currentUserId)
            .map(getReactionEmojiCode)
            .toList(),
    );
};
